/**
 * Owner: Masa Bayu
 * File: TaxonomyIndexPanel.tsx
 * Date:Time: 2026-09-15 21:14
 * Description: T2 categories or collections index — presentation links only.
 */

import type { QxreadTaxonomyKind, QxreadTaxonomyNode } from '@qx/qxread-core';

export interface TaxonomyIndexPanelProps {
  readonly kind: QxreadTaxonomyKind;
  readonly nodes: readonly QxreadTaxonomyNode[];
  readonly onNavigate: (path: string) => void;
}

export function TaxonomyIndexPanel({ kind, nodes, onNavigate }: TaxonomyIndexPanelProps) {
  const title = kind === 'category' ? 'Categories' : 'Collections';
  const basePath = kind === 'category' ? '/categories' : '/collections';

  return (
    <section className="route-panel" aria-labelledby="route-title">
      <p className="eyebrow">T2 Marketplace · {title}</p>
      <h2 id="route-title">{title}</h2>
      <p>
        {kind === 'category'
          ? 'Categories facet public catalog tags. Selecting a category never grants ownership.'
          : 'Collections are curated presentation indexes — not Library entitlements.'}
      </p>
      {nodes.length === 0 ? (
        <p role="status">No {title.toLowerCase()} yet.</p>
      ) : (
        <ul className="taxonomy-list" aria-label={title}>
          {nodes.map((node) => {
            const href = `${basePath}/${node.slug}`;
            return (
              <li key={node.taxonomyId}>
                <a
                  href={`#${href}`}
                  onClick={(event) => {
                    event.preventDefault();
                    onNavigate(href);
                  }}
                >
                  {node.label}
                </a>
                <span className="taxonomy-list__count">
                  {' '}
                  · {node.publicationIds.length} title
                  {node.publicationIds.length === 1 ? '' : 's'}
                </span>
              </li>
            );
          })}
        </ul>
      )}
      <p className="route-panel__meta" role="note">
        Taxonomy ≠ entitlement · Marketplace ≠ Commerce
      </p>
    </section>
  );
}
